import { oktaAuth } from "../../auth/services/oktaAuth";
import { getAdminAgentBrowserTokenScope } from "../utils/admin-agent.utils";
import { useSyncExternalStore } from "react";

const readSessionScope = (): string | undefined => {
  const token = oktaAuth.getAccessToken();

  try {
    return token ? getAdminAgentBrowserTokenScope(token, true) : undefined;
  } catch {
    return undefined;
  }
};

const subscribeSessionScope = (changed: () => void): (() => void) => {
  oktaAuth.tokenManager.on("added", changed);
  oktaAuth.tokenManager.on("renewed", changed);
  oktaAuth.tokenManager.on("removed", changed);
  oktaAuth.tokenManager.on("expired", changed);
  oktaAuth.tokenManager.on("set_storage", changed);

  return () => {
    oktaAuth.tokenManager.off("added", changed);
    oktaAuth.tokenManager.off("renewed", changed);
    oktaAuth.tokenManager.off("removed", changed);
    oktaAuth.tokenManager.off("expired", changed);
    oktaAuth.tokenManager.off("set_storage", changed);
  };
};

// Remove the old scope immediately on token-manager events, even before the general auth context catches up.
export const useAdminAgentSessionScope = (): string | undefined =>
  useSyncExternalStore(subscribeSessionScope, readSessionScope, () => undefined);
